import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import "../../components/custom-dialog/CustomDialog.styles.css";
import useWindowSize from "../../hooks/useWindowSize";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <FontAwesomeIcon icon={regular("times")} />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomDialogBox({
  dialogHeading,
  children,
  cancelFn,
  dialogStatus,
  disabled,
  style,
  t,
  isMobile,
  buttonArrayData,
  disablePadding=false,
  dialogWidth=null
}) {
  const windowSize = useWindowSize();
  const handleClose = () => {
    cancelFn(false);
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={dialogStatus}
        className={`cm-dialog-container ${
          !disabled ? "" : "cm-dialog-container-dis cm-pointer-none"
        }`}
        style={{
          ...style,
          width: windowSize.isMobile ? windowSize.screenWidth + "px" : "100%",
        }}
        sx={
          dialogWidth
            ? {
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: dialogWidth + " !important",
                  },
                },
              }
            : {}
        }
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {dialogHeading}
        </BootstrapDialogTitle>
        <DialogContent className={disablePadding ? "cm-disable-padding" : ""} dividers>{children}</DialogContent>
        {buttonArrayData?.length > 0 && (
          <DialogActions>
            <div className="d-flex">
              {buttonArrayData.map((el, ind) => {
                return (
                  <Button
                    key={ind}
                    autoFocus={false}
                    onClick={el.handleBtnClick}
                    className={`${el.cssSty} cm-dialog-action-btn px-3 py-2 cm-btn-radius fw-medium`}
                  >
                    {!!el.icon && (
                      <FontAwesomeIcon icon={el.icon} className="cm-mar-icon" />
                    )}
                    {t(el.btnName)}
                  </Button>
                );
              })}
            </div>
          </DialogActions>
        )}
      </BootstrapDialog>
    </div>
  );
}

CustomDialogBox.defaultProps = {
  dialogHeading: "",
  style: {},
};
